// actions
export const FETCH_BENCHMARKS = 'benchmarks/FETCH_BENCHMARKS';
export const FETCH_BENCHMARK = 'benchmarks/FETCH_BENCHMARK';
export const ADD_BENCHMARK = 'benchmarks/ADD_BENCHMARK';
